import { useState, useEffect } from "react";
import { PDFDocument } from "pdf-lib";
import Text from "./Text";
import Button from "./Buttons/Button";

export default function PDFMerger() {
    const [files, setFiles] = useState([]);
    const [merging, setMerging] = useState(false);
    const [error, setError] = useState("");

    const handleFileChange = (e) => {
        const newFiles = Array.from(e.target.files);
        setFiles((prev) => [...prev, ...newFiles]);
        setError("");
        e.target.value = ""; // erlaubt erneutes Auswählen derselben Datei
    };

    const removeFile = (index) => {
        setFiles((prev) => prev.filter((_, i) => i !== index));
    };

    const moveFile = (index, direction) => {
        setFiles((prev) => {
            const newFiles = [...prev];
            const targetIndex = index + direction;
            if (targetIndex < 0 || targetIndex >= newFiles.length) return prev;
            [newFiles[index], newFiles[targetIndex]] = [newFiles[targetIndex], newFiles[index]];
            return newFiles;
        });
    };

    const mergePdfs = async () => {
        if (files.length < 2) {
            setError("Bitte mindestens zwei PDF-Dateien auswählen.");
            return;
        }
        setError("");
        setMerging(true);
        try {
            const mergedPdf = await PDFDocument.create();

            for (const file of files) {
                const bytes = await file.arrayBuffer();
                const pdf = await PDFDocument.load(bytes);
                const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                pages.forEach((page) => mergedPdf.addPage(page));
            }

            const mergedBytes = await mergedPdf.save();
            const blob = new Blob([mergedBytes], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "zusammengefuegt.pdf";
            link.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            setError("Fehler beim Zusammenfügen der PDFs.");
        } finally {
            setMerging(false);
        }
    };

    return (
        <div className="flex flex-col gap-4">
            <div className="mb-3 flex flex-col gap-2">
                <Text type="body">Wählen Sie die PDF-Dateien aus, die Sie zusammenfügen möchten:</Text>
                <input
                    type="file"
                    accept="application/pdf"
                    multiple
                    onChange={handleFileChange}
                />
            </div>

            {files.length > 0 && (
                <ul style={{ listStyle: "none", padding: 0, marginBottom: 12 }}>
                    {files.map((file, index) => (
                        <li
                            key={`${file.name}-${index}`}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "6px 10px",
                                marginBottom: 6,
                                background: "#f3f4f6",
                                borderRadius: 6,
                            }}
                        >
                            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
                                {index + 1}. {file.name}
                            </span>
                            <div style={{ display: "flex", gap: 4, marginLeft: 8 }}>
                                <Button buttonColor="bg-blue-100" onClickAction={() => moveFile(index, -1)} disabled={index === 0}>↑</Button>
                                <Button buttonColor="bg-blue-100" onClickAction={() => moveFile(index, 1)} disabled={index === files.length - 1}>↓</Button>
                                <Button buttonColor="bg-red-100" onClickAction={() => removeFile(index)}>✕</Button>
                            </div>
                        </li>
                    ))}
                </ul>
            )}

            {error && <p style={{ color: "red" }}>{error}</p>}

            <Button buttonColor={merging || files.length < 2 ? "bg-gray-400" : "bg-green-100"} onClickAction={mergePdfs} disabled={merging || files.length < 2}>
                {merging ? "Wird zusammengefügt..." : "PDFs zusammenfügen"}
            </Button>
        </div>
    );
}